if (!customElements.get('sort-by')) {
    customElements.define(
      'sort-by',
      class SortBy extends HTMLElement {
        constructor() {
          super();
          this.elements = {
            select: this.querySelector("select"),
            input: this.querySelectorAll('option'),
            button: this.querySelector('button'),
            panel: this.querySelector('.disclosure__list-wrapper'),
            listItemLinks: this.querySelectorAll('li > a')
          };
          this.elements.button.addEventListener('click', this.openSelector.bind(this));
          this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
          this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
  
          this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
        }
  
        hidePanel() {
          this.elements.button.setAttribute('aria-expanded', 'false');
          this.elements.panel.setAttribute('hidden', true);
        }
  
        onContainerKeyUp(event) {
          if (event.code.toUpperCase() !== 'ESCAPE') return;
  
          if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
          this.hidePanel();
          event.stopPropagation();
          this.elements.button.focus();
        }
  
        onItemClick(event) {
          event.preventDefault();
          let newSortValue = event.target.dataset.sortValue;
          this.elements.select.value = newSortValue;
          this.elements.input.forEach((option) => {
            let optionValue = option.value;
            if (optionValue === newSortValue) {
                option.selected = true;
            } else {
                option.selected = false;
            }
          });
          this.elements.listItemLinks.forEach((listItem) => {
            let listValue = listItem.dataset.sortValue;
            if (listValue === newSortValue) {
                listItem.classList.add("disclosure__link--active");
            } else {
                listItem.classList.remove("disclosure__link--active");
            }
          })
          const form = this.closest('form');
          if (form) {
            var event = new Event('change', { 'bubbles': true });
            this.elements.select.dispatchEvent(event);
                //form.submit();
            this.elements.button.querySelector('span').innerHTML = newSortValue;
            this.hidePanel();
          }
        }
  
        openSelector(event) {
           event.preventDefault();
          this.elements.button.focus();
          this.elements.panel.toggleAttribute('hidden');
          this.elements.button.setAttribute(
            'aria-expanded',
            (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
          );
        }
  
        closeSelector(event) {
            event.preventDefault();
          const isChild =
            this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
          if (!event.relatedTarget || !isChild) {
            this.hidePanel();
          }
        }
      }
    );
  }
  